import styled from "styled-components";
import theme from "~/styles/theme";
import { Button } from "~/components/elements";

export const FormText = styled.div`
  padding: 0 16px;
  margin: 0 auto;
  text-align: center;
  width: 100%;

  strong {
    color: ${theme.palette.neutral.primary.key};
  }

  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    max-width: 310px;
    margin: 0 auto;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      max-width: 860px;
    }

    strong {
      font-family: ${theme.typography.fontFamily};
    }

    a {
      font-family: ${theme.typography.fontFamily};
      color: ${theme.palette.neutral.primary.key};
      text-decoration: underline;
    }
  }
`;

export const FormHolder = styled.div`
  padding: 0 16px;
  margin: 0 auto;
  text-align: center;
  width: 100%;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 496px;
  }

  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    max-width: 310px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      max-width: 860px;
      margin: 0 auto;
    }

    strong {
      font-family: ${theme.typography.fontFamily};
    }

    a {
      font-family: ${theme.typography.fontFamily};
      color: ${theme.palette.neutral.primary.key};
      text-decoration: underline;
    }
  }

  .signup-container {
    background-color: ${theme.palette.neutral.white};
  }
`;

export const Subtitle = styled.div`
  p {
    font-family: ${theme.typography.fontFamily};
    font-size: 24px;
    line-height: 32px;
    max-width: 329px;
    font-weight: 700;
    color: ${theme.palette.brand.primary.key};

    @media (min-width: ${theme.breakpoints.values.md}px) {
      max-width: 860px;
    }
  }
`;

export const FormLimiter = styled.form`
  button {
    width: 153px;
    display: block;
    
    &:hover {
      background-color: ${theme.palette.neutral.primary.medium};
      color: ${theme.palette.brand.primary.key};
      border-color: ${theme.palette.neutral.primary.medium};
    }
  }

  @media (max-width: ${theme.breakpoints.values.md}px) {
    button {
      width: 100%;
    }
  }  

  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 560px;
    margin: 0 auto;
  }

  a {
    display: block;
    width: fit-content;
    cursor: pointer;
  }
`;

export const ForgotLink = styled.span`
  width: fit-content;
  display: block;
  text-align: left;
  font-size: 14px;
  color: ${theme.palette.neutral.primary.key};
  font-family: ${theme.typography.fontFamilyRegular};
  text-decoration: underline;
  font-weight: 500;
`;

export const ButtonHolder = styled.div`
  display: flex;
  justify-content: flex-end;
  
  button {
    width: 158px;
    height: 56px;
  }
`;

export const TextHolder = styled.div`
  background-color: ${theme.palette.neutral.primary.light};
  padding: 48px;
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    font-size: 16px;
    color: ${theme.palette.brand.primary.key};
    font-family: ${theme.typography.fontFamily};
    text-align: center;
    font-weight: 700;
  }

  a {
    text-decoration: none;
  }

  button {
    width: 100%;
  }
`;

export const BtnSignUp = styled(Button)`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 2px solid ${theme.palette.brand.primary.key};
  cursor: pointer;
  padding: 10px 24px;
  border-radius: 32px;
  font-weight: 400;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 0;
    margin-right: 24px;
  }

  &:hover {
    border-color: ${theme.palette.brand.primary.key};
    background-color: ${theme.palette.brand.primary.key};

    span {
      color: ${theme.palette.neutral.primary.light};
      display: flex;
    }
  }

  span {
    color: ${theme.palette.brand.primary.key};
    display: flex;
  }
`;